/*
 * Segmented variant option + benefit badge (snippets/product-variant-picker.liquid).
 * Loaded only when the variant_picker block's "segmented_option" is set.
 *
 * CSS :has() drives the badge straight from the checked radio. This keeps data-benefit-active in sync
 * for browsers without :has(). It only reads radios and writes one data attribute; it never touches the
 * inputs global.js uses, and never throws.
 */
(function () {
  'use strict';
  if (window.__variantBenefitBadge) return;
  window.__variantBenefitBadge = true;

  function sync() {
    try {
      var groups = document.querySelectorAll('[data-variant-benefit-group]');
      for (var i = 0; i < groups.length; i++) {
        var input = groups[i].querySelector('input[type="radio"][data-variant-benefit]');
        var active = input && input.checked ? 'true' : 'false';
        if (groups[i].getAttribute('data-benefit-active') !== active) groups[i].setAttribute('data-benefit-active', active);
      }
    } catch (e) {
      /* never break the variant picker */
    }
  }

  try {
    // Capture phase: also sees global.js's non-bubbling `change` dispatched on <variant-selects>
    // after it re-checks a radio (skip sold-out / non-existent combinations).
    document.addEventListener('change', sync, true);
    // Back/forward cache and browser form-state restore can re-check a different radio.
    window.addEventListener('pageshow', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  } catch (e) {
    /* never break the page */
  }
})();
